// 公用mutations
const mutations = {
  SET_ENUM(state, data = {}) {
    state.enum = { ...state.enum, ...data }
  },
}
export default mutations
